import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=6ee82b8d&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"
import style0 from "./TicketDetails.vue?vue&type=style&index=0&id=6ee82b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee82b8d",
  null
  
)

export default component.exports